import React from 'react';

const DiscountValue = props => {
  return (
    <div className="DiscountValue" >
      毎月 {props.value}円 割引<br/>
      （税込 {props.valueWithTax}円）
    </div>
  );
};

export default DiscountValue;
